import req from "./http.js";

// 使用者列表
export const apiGetUserList = (page_idx, limit, keyword, sort_by) =>
  req(
    "get",
    `/admin/user/list?page=${page_idx}&limit=${limit}&key=${keyword}&sortby=${sort_by}`,
    null
  )
    .then(function (resp) {
      return resp.data.data;
    })
    .catch(function (error) {
      throw error;
    });

export const apiGetUserInfo = (id) =>
  req(
    "get",
    `/admin/user/getUserInfo?user_id=${id}`,
    null
  )
    .then(function (resp) {
      return resp.data.data;
    })
    .catch(function (error) {
      throw error;
    });

// 啟用/停用使用者
export const apiEnableUser = (params) =>
  req("put", `/admin/user/enable`, params)
    .then(function (resp) {
      return resp.data.data;
    })
    .catch(function (error) {
      throw error;
    });

// 代客操作 取得暫時是user身份的token
export const apiImpersonateUser = (params) =>
  req("post", `/admin/user/impersonateUser`, params)
    .then(function (resp) {
      return resp.data;
    })
    .catch(function (error) {
      throw error;
    });

// 加上是beta_user
export const apiAddRole = (params) =>
  req("post", `/admin/user/addRole`, params)
    .then(function (resp) {
      return resp.data;
    })
    .catch(function (error) {
      throw error;
    });

export const apiRemoveRole = (role, ids) =>
  req(
    "delete",
    `/admin/user/removeRole?target_role=${role}&user_ids=${ids}`,
    null
  )
    .then(function (resp) {
      return resp.data;
    })
    .catch(function (error) {
      throw error;
    });


export const apiAssignUserContainer = (params) =>
  req("post", `/admin/user/assignUserContainer`, params)
    .then(function (resp) {
      return resp.data;
    })
    .catch(function (error) {
      throw error;
    });

    export const apiSwitchUserContainerRoleEnable = (params) =>
      req("post", `/admin/user/switchUserContainerRoleEnable`, params)
        .then(function (resp) {
          return resp.data;
        })
        .catch(function (error) {
          throw error;
        });
    
